/**
 * Canonical URL suffixes for destination-product routes. Keep this in sync
 * with the user-facing page types in destinationProductPageUtils.
 */
export const DESTINATION_PRODUCT_DOT_ROUTE_PRODUCT_TYPES = [
  'Holiday-Packages',
  'Hotels',
  'Tours',
  'Holiday-Homes',
] as const
